import React, { useEffect} from "react";
import { connect } from "react-redux";
import { getOvertimeList } from "../../../../redux/overtime/overtimeState";
import { List } from "antd";
import { formatDateRange } from "utils/index";

const OvertimeTable = ({
	recordList, 
	pagination, 
	doSearch, 
}) => {
  	
	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <List
			dataSource={recordList}
			itemLayout="vertical"
			pagination={{
			...pagination,
			showTotal: (total, range) => `${range[0]} - ${range[1]} of ${total} records`,
			}}
			renderItem={(item) => {
			const statusKey = item.ots_status_name.toLowerCase();
	
			return (
				<List.Item key={item.ots_id} className="!p-0 !border-0 mt-2">
				<div className="p-4 border border-slate-200 rounded-xl hover:shadow-md transition-all">
					<div className="flex items-center justify-between">
					<div>
						<div className="flex items-center gap-1 font-semibold text-sm tracking-wide">
							
							<span>
								{formatDateRange(item?.date_time_start, null, null, true, true)}
							</span>
							<span> – </span> 
							<span>
								{formatDateRange(item?.date_time_end, null, null, true, true)}
							</span>
							<span>•</span> 
							<span>{item?.ots_status_id === 67 
									? item?.approved_duration_string
									: item?.duration_string 

								}
							</span>
						</div>
						<div className="text-xs text-slate-700 flex items-center gap-1 tracking-wide">
							<span>Date Filed: {formatDateRange(item?.created_at)}</span>
						</div>
					</div>
	
					<span className={`status-indicator ${statusKey}`}>
						{item.ots_status_name}
					</span>
					</div>
				</div>
				</List.Item>
			);
			}}
		/>
  	);
};

const mapStateToProps = (state) => ({
	recordList: state.overtime.overtimeList?.items,
	pagination: state.overtime.overtimeList?.pagination,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getOvertimeList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps )(OvertimeTable);
